import {
    ABASTECIMENTO_MODO_TELA,
    ABASTECIMENTO_AGUARDANDO,
    ABASTECIMENTO_LISTADO,
    ABASTECIMENTO_OPCOES
} from './abastecimentoActions';

const INITIAL_STATE = {
    modoTela: 'lista',
    registro: {},
    aguardando: false,
    lista: [],
    veiculos: [],
    fornecedores: [],
    usuarios: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ABASTECIMENTO_MODO_TELA:
            return {
                ...state,
                modoTela: action.payload.modo,
                registro: action.payload.registro || {}
            };
        case ABASTECIMENTO_AGUARDANDO:
            return {
                ...state,
                aguardando: action.payload
            };
        case ABASTECIMENTO_LISTADO:
            return {
                ...state,
                lista: action.payload || []
            };
        case ABASTECIMENTO_OPCOES:
            return {
                ...state,
                ...(action.payload || {})
            };
        default:
            return state;
    }
};
